import ApiService from '@/services/api.service'


const BioSetupService = {
    getAll( parameter, fromLogN = false) { 
      
      const params = {
          SearchCriteria: parameter.SearchCriteria,
          PageSize: parameter.PageSize,          
          PageNumber : parameter.PageNumber,
          NoteType: parameter.NoteType
      };

      if( fromLogN ){
        params.Active = parameter.Active
      }
      const requestData = {
        method: 'get',
        url: "/Mdbiopsychosocialsetuphdr",
        headers: {
        },
        params: params
      }     
      return ApiService.customRequest(requestData);         
    },
  
    get(id) {
      return ApiService.get(`/Mdbiopsychosocialsetuphdr/${id}`);
    },

    add(data){
      return ApiService.post(`/Mdbiopsychosocialsetuphdr`,data)
    },

    delete(id){
      return ApiService.delete(`/Mdbiopsychosocialsetuphdr/${id}`)
    },

    update(code,bio){
      return ApiService.put(`/Mdbiopsychosocialsetuphdr/${code}`,bio)
  }
    
  }
  
  export default BioSetupService;